export const DEFAULT_COORDINATES = { lat: 46.1445302, lng: 2.0474905 };
